// extracted by mini-css-extract-plugin
module.exports = {"container":"e2ff468f85--container--oUz4B","title":"e2ff468f85--title--nYMaI"};